import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { Add } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import { useIsSuperuser } from "hooks/users"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators as DataCreators } from "model/data"
import { track } from "helpers/analytics"
import Tooltip from "components/material/tooltip"
import { useAccountAlias } from "resources/account"
import EditSigmaSolution from "../edit-sigma-solution"

export default function CreateSolutionHeaderActions() {
  const dispatch = useDispatch()
  const isSuperuser = useIsSuperuser()
  const accountAlias = useAccountAlias()

  const refreshSigmaSolutions = useCallback(() => {
    const solutionsUrl = `/api/${accountAlias}/solutions/sigma`
    dispatch(DataCreators.load("sigmaSolutions", solutionsUrl, solutionsUrl))
  }, [dispatch, accountAlias])

  const openCreateSigmaWorkbook = () => {
    dispatch(DialogCreators.open({
      title: "Create Sigma Workbook Solution",
      content: <EditSigmaSolution onSuccess={refreshSigmaSolutions} />,
    }))
  }

  function toggleCreate() {
    openCreateSigmaWorkbook()
    track("solutions-create", { type: "sigma-workbook" })
  }

  if (!isSuperuser) {
    return null
  }

  return <>
    <Tooltip key="create" title="Create solution">
      <span>
        <IconButton
          key="create-solution"
          color="primary"
          className="create-solution desktop-button"
          onClick={toggleCreate}
          size="large"
        >
          <Add />
        </IconButton>
      </span>
    </Tooltip>
  </>
}
